// src/components/ForgotPassword.js
import React, { useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import PageSnackbars from '../common/PageSnackbars';
import { usePageSnackbar } from '../common/usePageSnackbar';
import axios from 'axios';
import AuthSplitShell from '../auth/AuthSplitShell';
import { authTitleSx, authSubtitleSx } from '../auth/authSplitShellSx';
import { Input, Button } from '../ui';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { setSuccessMessage, setErrorMessage, snackbarProps } = usePageSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/forgot-password', { email });
      setSuccessMessage(response.data.message || 'Password reset link has been sent to your email.');
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Failed to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthSplitShell variant="center">
        <Typography component="h1" sx={authTitleSx}>
          Forgot password
        </Typography>
        <Typography sx={authSubtitleSx}>
          Enter your email address and we&apos;ll send you a link to reset your password.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 2 }}>
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <Button type="submit" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={20} color="inherit" /> : 'Send reset link'}
          </Button>
          <Button component={Link} to="/login" variant="outline" fullWidth>
            Back to sign in
          </Button>
        </Box>
      </AuthSplitShell>
      <PageSnackbars {...snackbarProps} />
    </>
  );
};

export default ForgotPassword;
